<div class="modal fade callLogModal" tabindex="-1" data-backdrop="false" role="dialog" aria-labelledby="myLargeModalLabel"
     id="modalPopUp">
  <div id="call-log-modal-dialogue" class="modal-dialog" style="width: auto">
    <div class="modal-content" *ngIf="showCallLogModal">
      <div class="modal-header"
      [ngClass]="{'header-with-user': userInfo,'header-no-user': !userInfo,'stackcalls': userInfo && userInfo.state !== 'connected' && !isNotificationPopup,'notification-ringing': isNotificationPopup && userInfo?.state === 'ringing','notification-hangup': isNotificationPopup && (userInfo?.state === 'hangup' || userInfo?.state === 'missed'),'notification-recap': isNotificationPopup && userInfo?.state === 'recap_summary'}">
        <div class="drag-line" *ngIf="isNotificationPopup" (click)="closeModalConfirmation()" style="width:40px; border:2px solid #FFF;"></div>
        <!-- *ngIf="!userInfo" -->
        <h4  class="modal-title" translate *ngIf="!userInfo">
          Log.call
          <span class="pointer-cursor float-right" (click)="closeModalConfirmation()">
                <i class="fa fa-times" aria-hidden="true"></i>
          </span>
        </h4>
      <div class="info-bar" *ngIf="userInfo"  >
       
        <div class="info-left">
          <div class="back-icon" style="margin-right: 8px;" *ngIf="isNotificationPopup; else legacyBackIcon">
            <!-- Connected outbound call: same outgoing icon as call-activity -->
            <!-- <i *ngIf="userInfo.state === 'connected' && userInfo.direction === 'Outbound call' && userInfo.matchfound !== 1; else statusImage" -->
            <i *ngIf="isOutboundCall(userInfo) && userInfo.state === 'connected' &&userInfo.matchfound !== 1; else statusImage"
                class="fa-solid fa-phone-flip" style="font-size: 16px; color: #505B65;" aria-label="Outbound call"></i>
            <ng-template #statusImage>
                <img [src]="getDisplayIcon(userInfo)" [class.ringing]="userInfo.state === 'ringing'" alt="status">
            </ng-template>
          </div>
          <ng-template #legacyBackIcon>
            <div class="back-icon" *ngIf="userInfo.state == 'connected' else elsePart" style="margin-right: 8px;">
              <img src="/images/Phone.svg" alt="">
            </div>
            <ng-template #elsePart>
            <div class="back-icon" style="margin-right: 8px;">
              <img src="/images/Stacked.svg" alt="">
            </div>
            </ng-template>
          </ng-template>

          <div class="text">
            <div class="name">
              {{ (userInfo.name + (userInfo.contactnumber ? ' (' + (dialPad ? (userInfo.contactnumber | phoneDisplayFormat) : userInfo.contactnumber) + ')' : '')) | slice:0:67 }}{{ (userInfo.name + (userInfo.contactnumber ? ' (' + (dialPad ? (userInfo.contactnumber | phoneDisplayFormat) : userInfo.contactnumber) + ')' : ''))?.length > 67 ? '...' : '' }}
            </div>
            <div class="address" *ngIf="userInfo.address">
              {{ userInfo.address | slice:0:80 }}{{ userInfo.address?.length > 80? '...' : '' }}
            </div>
          </div>
        </div>
        <div class="info-right">
          <ng-container *ngIf="isNotificationPopup; else defaultCloseIcon">
            <ng-container *ngIf="userInfo?.customerId; else addNewLink">
              <span class="view-link-group">
                <a class="view-link" [attr.target]="dialPad ? null : '_blank'" [href]="'/customers/customer/' + userInfo.customerId + '/view/property/view'">View</a>
                <a [attr.target]="dialPad ? null : '_blank'" class="view-link" href="/customers/customer/{{ userInfo.customerId }}/view/property/view"><img src="/images/Openlink.svg" alt="" class="imgarrow"></a>
              </span>
            </ng-container>
            <ng-template #addNewLink>
              <a class="view-link" href="/customers/new_customer/1/new?type=dialpad" (click)="goToAddNewCustomer($event)">Add New</a>
            </ng-template>
          </ng-container>
          <ng-template #defaultCloseIcon>
            <span class="pointer-cursor close-icon" (click)="closeModalConfirmation()">
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
          </ng-template>
        </div>
      </div>
      </div>
      <div class="modal-body">
        <div class="modal-container">
            <ng-container *access="['UseCallTemplates.readaccess']">
                <div class="custom-tag-left-side-container" *ngIf="showCallNoteTemplateOption && customTagsList && customTagsList.length">
                    <div class="tag-header">
                        <div class="vertical-line"></div>
                        <div class="tag-header-text">Tags</div>
                    </div>
                    <div class="tag-list-container">
                        <div *ngIf="customTagForm && customTagsList.length" [formGroup]="customTagForm">
                            <ng-container *ngFor="let tag of customTagsList">
                                <div *ngIf="tag.fieldType === 'dropdown'" style="margin-bottom: 16px;">
                                    <label [class]="customTagForm.controls[tag.name].disabled ? '' : 'required_field'"
                                           translate>{{ tag.name }}</label>
                                    <select style="width: 100%; margin-bottom: 0px;" [formControlName]="tag.name"
                                            [disabled]="customTagForm.controls[tag.name].disabled"
                                            (blur)="replaceCustomTags('{'+tag.name+'}')">
                                        <option value="">-- Please select --</option>
                                        <option *ngFor="let value of tag.options" [value]="value"
                                                translate>{{ value }}
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="tag.fieldType === 'input'" style="margin-bottom: 16px;">
                                    <label
                                        [class]="customTagForm.controls[tag.name].disabled ? 'control-label' : 'control-label required_field'">{{ tag.name }}</label>
                                    <input type="text" [formControlName]="tag.name" class="input-tag-type"
                                           [disabled]="customTagForm.controls[tag.name].disabled"
                                           (blur)="replaceCustomTags('{'+tag.name+'}')"/>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
          <div class="log-container">
            <ng-container *ngIf="showCallNoteTemplateOption">
              <div class="template-wrapper call-note-template-wrapper">
                <div class="email-search-bar-container" *ngIf="showTemplateList">
                  <app-use-template #useTemplate [screen]="'call_note_template'" [screenLabel]="'Call note template'"
                                      [showAddNewTemplate]="showAddNewTemplate"
                                      (selectedItem)="setTemplateDetails($event)"
                                      (cancelEvent)="cancelTemplate()"
                                      [openDropDown]=showTemplateList>
                  </app-use-template>
                </div>
              </div>
            </ng-container>
            <ng-container>
              <form *ngIf="callForm" [formGroup]="callForm">
                  <div class="job-complete" *ngIf="callActivityShow">
                      <label class="checkbox-button margin-btm0" for="callComplete">
                          <input class="checkbox-button__input" type="checkbox" id="callComplete"
                                 [checked]="completed" (change)="completeActivity($event)"/>
                          <span class="checkbox-button__control complete-check"></span>
                          <span class="checkbox-button__label" translate><i class="fa fa-phone margin-r5"
                                                                            aria-hidden="true"></i>
                      <span translate>activity.call.today</span></span>
                      </label>
                  </div>
                  <ng-container *access="['UseCallTemplates.readaccess']">
                      <div class="template-recommendation-bar" *ngIf="showCallNoteTemplateOption && showRecommendation">
                          <div class="dis-flex align-items-center" style="gap: 6px;">
                              <i class="fa-solid fa-book" style="color: #505B65"></i>
                              <span>It's recommended that you use the {{ selectedCallNoteTemplate.templateName || (selectedCallNoteTemplate['template'] && selectedCallNoteTemplate['template']['name']) }}</span>
                              <a class="ml-auto pointer-cursor" (click)="setTemplateDetails(selectedCallNoteTemplate)">Use
                                  this template</a>
                          </div>
                      </div>
                  </ng-container>

                  <ng-container *ngIf="userInfo?.dialpad === 1 && userInfo?.customerId != ''; else callTypeSelect">
                    <div [class.dialpad-mode]="dialPad">
                    <input type="text" class="full-width-select2 select-blk" placeholder="To"
                    [value]="dialPad ? (userInfo?.contactnumber | phoneDisplayFormat) : userInfo?.contactnumber" disabled/>

                    <input type="text" class="full-width-select2 select-blk" placeholder="Inbound / Outbound call"
                    [value]="dialPad ? (userInfo?.direction | firstLetterUpper) : userInfo?.direction" disabled/>
                    </div>
                  </ng-container>
                  
                <ng-template #callTypeSelect>
                <select  class="full-width-select2 select-blk activity-selected" placeholder="To"
                         formControlName="contactTelephoneId">
                  <option hidden value="" disabled selected>To</option>
                  <option  *ngIf="isContactNotFound" class="no-contact-found" disabled> <span>No matched found</span> </option>
                  <ng-container *ngFor="let contact of customerCallDetails">
                    <optgroup class="activity-option-color" label="{{contact?.contactName}}">
                      <option *ngFor="let details of contact?.contacts" value="{{details?.id}}">
                        {{details?.contactNumber}}</option>
                    </optgroup>
                  </ng-container>
                </select>
                <select class="full-width-select2 select-blk activity-selected" formControlName="callType">
                  <option hidden value="" disabled selected>Inbound/outbound call</option>
                  <option  class = "activity-option-color" *ngFor="let type of callType" [value]="type?.id">
                    {{type?.value}}</option>
                </select>
              </ng-template>
                <!--<textarea id="email-template-message" style="height: 400px;" rows="8" cols="70"
                          class="controls textareatest  tiny-mce-single-line-input-wrapper"
                          [ngStyle]="{'height': callActivityShow ? '240px' : '304px' }"
                          formControlName="note">
                  </textarea>-->
                  <div class="restrict-select-tag">
                      <quill-editor-custom [tagsList]="usersList" [form]="callForm" [screen]="screen" [dialPad]="dialPad" (contentChanged)="onContentChange($event)"
                                           [lableName]="'note'"  ></quill-editor-custom>
                  </div>

              </form>
            </ng-container>
            <!-- *access="['UseCallFields.readaccess']" -->
            <ng-container >
              <div class="custom-fields-section" *ngIf="showCallCustomFields && customFieldForm && customFields && customFields.length" [formGroup]="customFieldForm">
                  <ng-container *ngFor="let cf of customFields">
                      <ng-container *ngIf="isFieldsValid(cf.value)">
                          <div class="custom-field-input-box">
                              <label class="control-label required_field">{{ (dialPad && cf.key === 'Outcome of call') ? 'Call outcome' : cf.key }}</label>
                              <select *ngIf="!dialPad" type="text" [formControlName]="cf.key" class="input-tag-type" >
                                  <option value="" disabled>-- Please select --</option>
                                  <option *ngFor="let value of cf.value" [ngValue]="value" [hidden]="value.archived == 1" >{{value.description}}</option>
                              </select>
                              <app-cs-drop-down class="custom-field-input-box" *ngIf="dialPad" [ddConfig]="cf.ddConfig"
                                                 (ddItemClick)="onCustomFieldDdSelect(cf, $event)"></app-cs-drop-down>
                          </div>
                      </ng-container>
                  </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
              
      </div>


      <!-- Footer -->
      <div class="modal-footer" [ngClass]="{'attachments-over':modalBack == true}">
        <div class="row-fluid dis-flex">
          <div class="dis-flex align-items-center" *ngIf="showCallNoteTemplateOption">
            <span style="padding: 4px; cursor: pointer" (click)="showTemplateOptions()" [ngClass]="{'active-icon':showTemplateList == true}" *access="['UseCallTemplates.readaccess']">
              <i class="fa-regular fa-folder-open"></i>
            </span>
          </div>
          <div class="element-alignment-center ml-auto" *ngIf="userInfo?.dialpad === 1 && userInfo?.customerId != ''; else savetemplate">
            <button *ngIf="callForm && customFieldForm" class="btn btn-primary" (click)="saveCallCommunication()" [disabled]="!customFieldForm.valid" translate>Save</button>
          </div>

          <ng-template  #savetemplate>
          <div class="element-alignment-center ml-auto" >
            <span class="activity-left" *ngIf="callinfo?.dialpad != 1">
              <div class="schedule-check">
                <label class="checkbox-button checkbox-text-center" for="completeScheduleActivity">
                  <input class="checkbox-button__input" type="checkbox" id="completeScheduleActivity"
                         [checked]="scheduled" (change)="isScheduledActivity($event)" />
                  <span class="checkbox-button__control"></span>
                  <span class="checkbox-button__label" translate="">Schedule.new.activity</span>
                </label>
              </div>
            </span>
            <button class="btn disgard-button activity-modal-discard" (click)="closeModalConfirmation()" translate>
              Discard
            </button>
            
            <button 
            *ngIf="callForm"
            class="btn btn-primary"
            [disabled]="!callForm.valid || 
                        saveDisabled || 
                        (customFieldForm && !customFieldForm.valid && isCallCustomFieldEnabled && showCallCustomFields) || 
                        (!customTagForm.disabled && !customTagForm.valid)"
            (click)="callinfo?.dialpad === 1 ? saveCall('dialpad') : saveCall()"
            translate>
            Save
          </button>
          </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>



